{
	"title": "Настройки",
	"subtitle": "Управление профилем, безопасностью, уведомлениями и подпиской.",
	"savedJust": "Сохранено",
	"saving": "Сохранение…",
	"saveFailed": "Не удалось сохранить",
	"version": "Версия {version}",
	"logout": "Выйти",
	"logoutAll": "Выйти везде",
	"logoutSuccess": "Вы вышли из аккаунта",
	"logoutAllSuccess": "Завершены все активные сессии",
	"actions": {
		"cancel": "Отмена"
	},
	"readonly": {
		"banner": "Тариф понижен — доступен режим чтения. Доступны просмотр и экспорт, но не правки. Перейти к подписке →"
	},
	"grace": {
		"banner": "Аккаунт будет удалён через {days, plural, one {# день} few {# дня} other {# дней}}",
		"restoreCta": "Отменить удаление",
		"restored": "Удаление отменено. Аккаунт активен."
	},
	"nav": {
		"backToSettings": "Назад к настройкам",
		"switchSection": "Перейти к разделу",
		"section": {
			"account": "Аккаунт",
			"communications": "Коммуникации",
			"privacy": "Конфиденциальность"
		},
		"profile": "Профиль",
		"account": "Аккаунт",
		"devices": "Устройства",
		"appearance": "Внешний вид",
		"offline": "Офлайн",
		"notifications": "Уведомления",
		"streak": "Серия обучения",
		"privacy": "Приватность",
		"danger": "Опасная зона",
		"billing": "Подписка",
		"desc": {
			"profile": "Имя, аватар, образование",
			"account": "Вход, согласия, сессии",
			"devices": "Активные устройства",
			"appearance": "Тема и подсветка терминов",
			"offline": "Данные и аудио на устройстве",
			"notifications": "Каналы и типы событий",
			"streak": "Цель, напоминание, заморозки",
			"billing": "Тариф, оплата, квоты",
			"privacy": "Данные и согласия",
			"danger": "Удаление аккаунта",
			"language": "Интерфейс и язык генерации"
		},
		"language": "Язык"
	},
	"streak": {
		"title": "Серия обучения",
		"subtitle": "Дневная цель, напоминание и авто-заморозка серии.",
		"goalSection": "Дневная цель",
		"goalLabel": "Сколько заниматься в день",
		"goalHelp": "Цель засчитывается, когда за день набрано столько минут обучения.",
		"goalOption": "{minutes} мин/день",
		"reminderSection": "Напоминание",
		"reminderLabel": "Время напоминания",
		"reminderHelp": "Если цель к этому часу не выполнена — пришлём напоминание, чтобы не потерять серию.",
		"reminderOption": "{hour}:00",
		"tzNote": "Часовой пояс: {tz}",
		"freezeSection": "Заморозки",
		"autoFreezeLabel": "Авто-заморозка",
		"autoFreezeHelp": "Автоматически тратить заморозку из запаса, чтобы серия не прервалась в пропущенный день. Начисляется 1 в неделю.",
		"saveError": "Не удалось сохранить"
	},
	"profile": {
		"title": "Профиль",
		"avatar": "Аватар",
		"name": "Имя",
		"email": "Email",
		"emailHelp": "Адрес аккаунта — используется для входа и уведомлений.",
		"autoGenerate": {
			"title": "Автогенерация материалов",
			"description": "По умолчанию выключена: материалы к темам готовит курс. Этот тумблер влияет только на отдельно загруженный материал.",
			"label": "Готовить материалы при загрузке",
			"help": "Когда включено, сразу после обработки создаются конспект, карточки, тест и глоссарий — по этому одному материалу, а не по курсу. Тратит дневной лимит AI-генераций. Когда выключено, любой из них можно запустить вручную с материала.",
			"offHint": "Выключено — курс сам готовит всё для своих тем."
		},
		"timezone": "Часовой пояс",
		"timezoneHelp": "Используется для напоминаний и расписания.",
		"saved": "Профиль сохранён",
		"saveError": "Не удалось сохранить профиль",
		"saveHint": "Изменения вступают в силу сразу после сохранения.",
		"manageInIecId": "Изменить в IEC ID",
		"nameManaged": "Имя приходит из единого профиля IEC ID.",
		"avatarOwnHint": "Показывается фото из единого профиля IEC ID. Можно поставить своё — только для StudyHub, в профиле оно не изменится.",
		"avatarUpload": "Загрузить своё",
		"avatarReplace": "Заменить фото",
		"avatarClear": "Убрать своё",
		"avatarCleared": "Своё фото убрано — снова показывается фото из профиля",
		"avatarUploaded": "Фото обновлено",
		"avatarUploadError": "Не удалось загрузить фото",
		"avatarErrors": {
			"invalidType": "Требуется формат JPEG, PNG или WebP",
			"tooLarge": "Размер файла превышает 5 МБ"
		},
		"avatarCrop": {
			"title": "Кадрирование аватара",
			"zoom": "Масштаб",
			"apply": "Применить",
			"saving": "Загрузка…"
		}
	},
	"account": {
		"title": "Аккаунт",
		"subtitle": "Управление входом, безопасностью и согласиями.",
		"email": "Email",
		"registered": "Зарегистрирован",
		"lastSeen": "Последний вход",
		"consents": "Согласия",
		"consentsHistory": "Показать всю историю",
		"consentsLoadError": "Не удалось загрузить историю согласий",
		"consentsEmpty": "История согласий пуста",
		"session": "Сессия",
		"logoutThis": "Выйти из этого устройства",
		"logoutAll": "Выйти везде",
		"relatedActions": "Связанные действия:",
		"linkDevices": "Активные устройства",
		"linkDanger": "Удалить аккаунт"
	},
	"devices": {
		"title": "Устройства",
		"subtitle": "Сессии, через которые ты сейчас вошёл. Заверши лишние.",
		"current": "Текущее устройство",
		"lastActive": "Последняя активность: {when}",
		"revoke": "Завершить сессию",
		"revokeAll": "Выйти везде",
		"revokeConfirmTitle": "Завершить сессию?",
		"revokeConfirmBody": "Устройство «{device}» будет отключено. Понадобится повторный вход.",
		"revokeAllConfirmTitle": "Выйти со всех устройств?",
		"revokeAllConfirmBody": "Будут завершены все сессии, включая текущую. Понадобится повторный вход.",
		"revokeSuccess": "Сессия завершена",
		"revokeAllSuccess": "Все сессии завершены",
		"pushActive": "Push активен",
		"pushNotConfigured": "Push: не настроен",
		"notRecognizedHint": "Не узнаёшь устройство? Заверши везде и смени пароль.",
		"loadErrorTitle": "Не удалось загрузить устройства",
		"loadErrorBody": "Проверь соединение и попробуй снова.",
		"retry": "Повторить",
		"emptyTitle": "Активных сессий нет",
		"emptyBody": "Список устройств появится после входа в аккаунт.",
		"columns": {
			"device": "Устройство",
			"location": "Локация",
			"lastActive": "Активность",
			"actions": ""
		}
	},
	"notifications": {
		"title": "Уведомления",
		"subtitle": "Где и про что StudyHub имеет право тебя побеспокоить.",
		"channels": "Каналы доставки",
		"types": "Типы событий",
		"quietHours": "Тихие часы",
		"quietHoursDescription": "Не присылать push в выбранный период.",
		"quietFrom": "С",
		"quietTo": "До",
		"channel": {
			"webPush": "Push в браузере",
			"mobilePush": "Push в приложении",
			"email": "Email",
			"inApp": "В приложении"
		},
		"channelHelp": {
			"webPushGranted": "Этот браузер: разрешено",
			"webPushDefault": "Нажми, чтобы разрешить уведомления в этом браузере",
			"webPushPermission": "Этот браузер: разрешено",
			"webPushDenied": "Браузер запретил уведомления. Открой настройки сайта.",
			"webPushUnsupported": "Этот браузер не поддерживает push-уведомления",
			"webPushNoVapid": "Push в браузере временно недоступен",
			"mobilePushMobile": "Это устройство: активно",
			"mobilePushWeb": "Работает в мобильном приложении StudyHub",
			"inApp": "Всегда работает — отключи если хочешь тишины"
		},
		"webPushError": {
			"enabled": "Push в браузере включён",
			"denied": "Разрешение на уведомления не выдано. Включи их в настройках браузера.",
			"unsupported": "Этот браузер не поддерживает push-уведомления.",
			"noVapid": "Push в браузере сейчас недоступен. Попробуй позже.",
			"error": "Не удалось включить push в браузере."
		},
		"type": {
			"aiReady": "AI: задача готова (конспект, карточки)",
			"srsReminder": "Напоминания SRS",
			"streaks": "Стрики (не потеряй прогресс)",
			"quota": "Лимиты тарифа (90% использовано)",
			"subscription": "Подписка и оплата",
			"security": "Безопасность",
			"product": "Новости продукта",
			"marketing": "Маркетинг (тарифы, акции)",
			"digest": "Недельный дайджест",
			"recommendations": "Рекомендации",
			"quotaNoSale": "Лимиты использования (израсходовано 90%)"
		},
		"securityLocked": "Всегда включено — критичные события",
		"tzNote": "Часовой пояс: {tz} (из профиля)",
		"saved": "Уведомления сохранены",
		"saveError": "Не удалось сохранить настройки уведомлений",
		"marketingRevoked": "Рассылки отключены в профиле IEC ID. Включить их можно там же — решение действует во всех сервисах.",
		"srsTime": "Время напоминания",
		"srsTimeHelp": "Push приходит в это время, если есть карточки к повтору.",
		"typeHelp": {
			"aiReady": "Приходит, когда AI закончил работу: готов конспект, набор карточек, тест, аудио-резюме или разбор эссе.",
			"srsReminder": "Ежедневное напоминание повторить карточки, у которых подошёл срок. Приходит только если есть что повторять.",
			"streaks": "Напоминание позаниматься, пока серия дней не прервалась.",
			"quota": "Предупреждение, что израсходовано 90% дневного или месячного лимита тарифа.",
			"subscription": "Оплата прошла или не прошла, тариф продлён, изменён или заканчивается.",
			"security": "Вход с нового устройства, смена способа входа, запрос на удаление аккаунта. Отключить нельзя.",
			"product": "Редкие письма о новых возможностях StudyHub и заметных изменениях.",
			"marketing": "Акции, скидки и специальные предложения по тарифам. Не влияет на служебные письма.",
			"digest": "Раз в неделю — сводка: сколько занимался, что повторил, где просели результаты.",
			"recommendations": "Персональные подборки: что повторить, какие пробелы закрыть, какой курс продолжить.",
			"quotaNoSale": "Предупреждение, что израсходовано 90% дневного или месячного лимита."
		}
	},
	"privacy": {
		"title": "Приватность",
		"subtitle": "Как мы используем твои данные и что ты можешь скрыть.",
		"consentsLoadError": "Не удалось загрузить согласия",
		"consentsEmpty": "Согласий пока нет",
		"aiTrainingNoticeTitle": "Конфиденциальность материалов",
		"aiTrainingNotice": "Твои материалы доступны только тебе и используются исключительно для того, чтобы генерировать конспекты, карточки, тесты и ответы репетитора по твоему материалу. AI-провайдер обрабатывает их по запросу — промпты и ответы не сохраняются на стороне модели.",
		"aiTrainingDisabled": "Приватно",
		"consentsAccepted": "Принятые согласия",
		"dataUsage": "Использование данных",
		"marketing": "Маркетинговые письма",
		"learnMore": "Подробнее",
		"dataExport": "Экспорт данных",
		"dataExportHeading": "Экспортировать мои данные",
		"dataExportIntro": "Получи машиночитаемую копию своих данных в StudyHub — по GDPR ст. 20 (право на переносимость данных).",
		"dataExportIncludesTitle": "В архив войдёт:",
		"dataExportIncludes": "Профиль, согласия, материалы, конспекты, карточки, тесты и попытки, сессии репетитора, учебные планы, календарь, аудио-резюме, эссе, визуальные разборы.",
		"dataExportExcludesTitle": "Не войдёт:",
		"dataExportExcludes": "Оригинальные файлы (загруженные документы, аудио- и видеозаписи) — они остаются доступны в приложении до удаления аккаунта.",
		"dataExportCta": "Запросить экспорт данных",
		"dataExportPending": "Отправляем…",
		"dataExportSuccess": "Письмо со ссылкой придёт на твою почту. Ссылка действует 7 дней.",
		"dataExportRateLimited": "Ты уже запрашивал экспорт недавно. Новый можно запросить раз в неделю.",
		"dataExportError": "Не удалось запросить экспорт данных",
		"marketingMoved": "Настраивается в разделе «Уведомления» — вместе с остальными письмами и пушами.",
		"cookieChoices": "Cookie и персонализация",
		"cookieChoicesHelp": "Выбор хранится в IEC ID и действует во всех сервисах и приложениях IEC.",
		"cookieChoiceOn": "Вкл.",
		"cookieChoiceOff": "Выкл.",
		"cookieChoiceUndecided": "Не выбрано",
		"cookieChoicesChange": "Изменить",
		"analyticsManageInIecId": "Управлять cookie в IEC ID",
		"aiSharing": "Отправка данных AI-сервисам",
		"aiSharingHelp": "Нужна для конспектов, карточек, тестов, репетитора и расшифровки. Данные получают Google (Gemini API) и, для поиска в интернете, Exa. Если выключить, AI-функции не работают и ничего не отправляется.",
		"aiSharingDetails": "Что и кому отправляется",
		"aiSharingOnToast": "AI-функции включены",
		"aiSharingOffToast": "AI-функции выключены — AI-сервисам ничего не отправляется"
	},
	"danger": {
		"title": "Опасная зона",
		"subtitle": "Необратимые действия. Подумай дважды.",
		"deleteHeading": "Удаление аккаунта",
		"deleteIntro": "Сначала мягкая деактивация, затем 30 дней на отмену.",
		"whatHappens": "Что произойдёт:",
		"bullet1": "Аккаунт деактивируется сразу — ты выйдешь из всех устройств",
		"bullet2": "30 дней даётся на отмену через email-ссылку или повторный вход",
		"bullet3": "После 30 дней — все данные удалятся безвозвратно: материалы, конспекты, карточки, история чатов, записи лекций, эссе, аналитика",
		"bullet4": "Активная подписка не возвращается",
		"bullet5": "Email освободится через 90 дней",
		"bullet6": "Единый профиль IEC ID остаётся — удаляется только аккаунт StudyHub",
		"deleteCta": "Удалить аккаунт",
		"graceHeading": "Аккаунт будет удалён",
		"graceCountdownHint": "До окончательного удаления ещё можно всё отменить.",
		"graceRequested": "Запрошено: {date}",
		"graceWipeAt": "Полное удаление: {date}",
		"graceRemaining": "{days, plural, one {# день} few {# дня} other {# дней}}",
		"graceRemainingLabel": "Осталось",
		"graceRequestedLabel": "Запрошено",
		"graceWipeLabel": "Удаление",
		"graceCanRestore": "Ты можешь отменить удаление прямо сейчас:",
		"graceRestoreCta": "Отменить удаление",
		"graceRestoreViaEmail": "Чтобы отменить удаление, перейди по ссылке из письма, отправленного на твою почту.",
		"graceAfterIrreversible": "После hard delete восстановить данные невозможно.",
		"confirmTitle": "Удаление аккаунта",
		"confirmBody": "Чтобы подтвердить, введи слово «УДАЛИТЬ» большими буквами.",
		"confirmTypeWord": "УДАЛИТЬ",
		"confirmInputLabel": "Подтверждение",
		"confirmCta": "Удалить навсегда",
		"deletionRequested": "Удаление запрошено. На email отправлена ссылка для отмены.",
		"restored": "Удаление отменено. Аккаунт активен.",
		"deleteError": "Не удалось запросить удаление"
	},
	"appearance": {
		"title": "Внешний вид",
		"subtitle": "Тема оформления и подсветка терминов в текстах.",
		"saveError": "Не удалось сохранить настройки",
		"theme": "Тема",
		"themeLight": "Светлая",
		"themeDark": "Тёмная",
		"themeSystem": "Системная",
		"themeUseSystem": "Использовать системную",
		"themeStatus": "Сейчас: {resolved} (системная: {system})",
		"themeSystemStatus": "Следует системной — сейчас: {resolved}"
	},
	"reading": {
		"title": "Чтение",
		"subtitle": "Как ведут себя термины глоссария в конспектах и транскриптах.",
		"glossaryHighlight": {
			"title": "Подсвечивать термины",
			"description": "Термины глоссария отмечаются пунктиром в конспектах, транскриптах и ответах репетитора. В карточках и тестах — никогда."
		},
		"glossaryCourseOnly": {
			"title": "Только термины текущего курса",
			"description": "Вне курса подсвечиваем лишь ключевые термины. Полезно, когда глоссарий разросся."
		},
		"saveError": "Не удалось сохранить настройки чтения"
	},
	"offline": {
		"title": "Офлайн",
		"subtitle": "Что StudyHub хранит на этом устройстве.",
		"audioPrefetch": {
			"title": "Скачивать аудио заранее",
			"description": "Как только аудио-резюме темы готово, оно скачивается на устройство — можно слушать без сети."
		},
		"wifiOnly": {
			"title": "Только по Wi-Fi",
			"description": "По мобильной сети ничего не качаем. Режим экономии трафика соблюдается всегда."
		},
		"usage": "Скачанное аудио: {size}",
		"clear": "Очистить",
		"cleared": "Кэш аудио очищен",
		"clearError": "Не удалось очистить кэш",
		"unavailable": "Работает в приложении и в браузерах с поддержкой кэширования.",
		"saveError": "Не удалось сохранить настройки офлайна",
		"localData": {
			"title": "Данные на устройстве",
			"description": "Учебные данные скачиваются автоматически и доступны без сети.",
			"rowLabel": "Учебная база",
			"rowDescription": "Курсы, конспекты, карточки, тесты, планы и календарь. Синхронизируются сами — удалять вручную не нужно."
		},
		"audio": {
			"title": "Аудио-резюме",
			"description": "Озвученные разборы тем — единственное, что не попадает в учебную базу и качается отдельно."
		},
		"images": {
			"title": "Иллюстрации",
			"description": "Изображения из материалов и заметок — кэшируются отдельно от базы данных обучения.",
			"usage": "Кэш изображений: {size}",
			"hint": "Очистка не удалит ваши заметки или учебные данные.",
			"cleared": "Кэш изображений очищен",
			"clearError": "Не удалось очистить кэш изображений"
		},
		"syncIssues": {
			"title": "Ошибки синхронизации",
			"description": "Изменения, которые не удалось отправить на сервер. Разрешите их здесь, чтобы не потерять.",
			"retry": "Повторить",
			"open": "Открыть",
			"keepServer": "Оставить версию сервера",
			"keepServerDone": "Разрешено — оставлена версия сервера",
			"copied": "Скопировано в буфер обмена",
			"actionError": "Действие не выполнено — попробуйте снова",
			"reason": {
				"forbidden": "Действие запрещено",
				"invalid": "Некорректные данные",
				"conflict": "Конфликт с сервером",
				"dropped": "Не удалось отправить после нескольких попыток"
			},
			"entity": {
				"note": "Заметка {id}",
				"material": "Материал {id}",
				"flashcardSet": "Набор карточек {id}",
				"item": "Элемент {id}",
				"studyPlan": "Учебный план {id}",
				"recording": "Запись {id}",
				"calendarEvent": "Событие {id}",
				"characterSession": "Чат с персонажем {id}"
			},
			"copyText": "Скопировать текст",
			"dismiss": "Удалить из списка",
			"dismissDone": "Удалено из списка — сохранена версия с сервера",
			"retrySent": "Изменения отправлены на сервер",
			"retryRejected": "Сервер отклонил изменение — оно остаётся в списке",
			"retryOffline": "Нет подключения — изменение остаётся в списке",
			"retryNoSnapshot": "Снимок этого изменения не был сохранён — отправлять нечего",
			"noSnapshot": "Восстановить автоматически не выйдет — скопируй текст",
			"readOnlyHint": "Это изменение не требует отправки — данные уже есть на сервере. Удалите его из списка."
		}
	},
	"billing": {
		"title": "Подписка",
		"subtitle": "Тариф, способы оплаты и квоты использования.",
		"currentPlan": "Текущий тариф",
		"manage": "Управлять подпиской",
		"details": "Подробности тарифов на странице «Подписка».",
		"openBilling": "Перейти к подписке",
		"planLabel": "Тариф {tier}",
		"freeTagline": "Базовый тариф — без оплаты",
		"cycleMonth": "мес",
		"cycleYear": "год",
		"statusTrial": "Пробный период",
		"statusCancelling": "Отменяется",
		"renewsOn": "Продление: {date}",
		"trialUntil": "Пробный период до {date}",
		"endsOn": "Доступ до {date}",
		"upgradeCta": "Перейти на Plus",
		"upgradeToPro": "Перейти на Pro",
		"manageCta": "Управлять подпиской",
		"viewAllPlans": "Все тарифы",
		"quotaTitle": "Квоты использования",
		"quota": {
			"notes": "Конспекты",
			"recordings": "Записи лекций",
			"audioRecaps": "Аудио-резюме"
		},
		"quotaUnlimited": "Безлимит",
		"quotaOf": "из {limit}",
		"compareLimits": "Сравнить лимиты тарифов",
		"paymentTitle": "Способ оплаты",
		"paymentDefault": "Карта",
		"paymentLast4": "•••• {last4}",
		"paymentManagedByProvider": "Управляется платёжным провайдером",
		"paymentUpdate": "Обновить"
	},
	"profileMenu": {
		"profile": "Профиль",
		"settings": "Настройки",
		"billing": "Подписка и тариф",
		"help": "Помощь и поддержка",
		"replayOnboarding": "Повторить онбординг",
		"legal": "Юридические документы",
		"logout": "Выйти",
		"tierFree": "Free",
		"tierPlus": "Plus",
		"tierPro": "Pro",
		"upsell": "Pro доступен",
		"appearance": "Внешний вид",
		"language": "Язык",
		"manageAccount": "Управлять аккаунтом"
	},
	"language": {
		"title": "Язык",
		"subtitle": "Язык интерфейса и язык, на котором AI создаёт материалы.",
		"section": "Язык",
		"ui": "Язык интерфейса",
		"uiHelp": "Сменится мгновенно. Тексты материалов остаются на оригинальном языке.",
		"generation": "Язык генерируемых материалов",
		"generationHelp": "На этом языке AI создаёт конспекты, карточки, тесты, глоссарий, аудио и визуальные объяснения. Распознавание загруженных файлов остаётся на языке оригинала.",
		"answerSameAsUi": "Язык интерфейса",
		"answerSourceLang": "Язык материала",
		"saveError": "Не удалось сохранить настройки языка"
	}
}
